import { CONFIGURACION_EDUCACION, CONFIGURACION_CATEGORIAS_EMPRESAS, CONFIGURACION_EXTENSIONES, CONFIGURACION_REQUERIMIENTOS, CONFIGURACION_DEPENDENCIAS, CONFIGURACION_GIMNASIOS, CONFIGURACION_CABINAS, CONFIGURACION_AUDITORIOS, CONFIGURACION_PADELS, CONFIGURACION_ASESORES } from '../actions/types';

const initialState = {
    educacion: {
        listado: [],
        detalles: null, 
        listado_instituciones: [],
        detalles_institucion: null
    }, 
    categorias_empresas: {
        listado: [],
        detalles: null
    }, 
    extensiones: {
        listado: [],
        detalles: null
    }, 
    requerimientos: {
        listado: [],
        detalles: null
    }, 
    dependencias: {
        listado: [],
        detalles: null
    }, 
    cabinas: {
        listado: [],
        detalles: null
    }, 
    auditorios: {
        listado: [],
        detalles: null
    }, 
    padels: {
        listado: [],
        detalles: null
    }, 
    gimnasios: {
        listado: [],
        detalles: null
    },
    asesores: {
        listado: [],
        detalles: null
    }
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case CONFIGURACION_EDUCACION.BUSCAR:
            return {
                ...state,
                educacion: {
                    ...state.educacion, 
                    listado: payload
                }
            };

        case CONFIGURACION_EDUCACION.AGREGAR:
            let niveles_agregar = state.educacion.listado;

            niveles_agregar = [
                ...niveles_agregar, payload
            ];

            niveles_agregar.sort(function (a, b) {
                if (a.orden > b.orden) {
                    return 1;
                }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado: niveles_agregar
                }
            };

        case CONFIGURACION_EDUCACION.DETALLES:
            return {
                ...state,
                educacion: {
                    ...state.educacion, 
                    detalles: payload
                }
            };

        case CONFIGURACION_EDUCACION.EDITAR:
            let niveles_editar = state.educacion.listado;

            niveles_editar = niveles_editar.map(nivel => nivel._id === payload._id ? payload : nivel);

            niveles_editar.sort(function (a, b) {
                if (a.orden > b.orden) {
                    return 1;
                }
                if (a.orden < b.orden) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado: niveles_editar
                }
            };

        case CONFIGURACION_EDUCACION.ELIMINAR:
            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado: state.educacion.listado.filter( nivel => nivel._id !== payload.id )
                }
            };

        case CONFIGURACION_EDUCACION.BUSCAR_INSTITUCIONES:
            return {
                ...state,
                educacion: {
                    ...state.educacion, 
                    listado_instituciones: payload
                }
            };

        case CONFIGURACION_EDUCACION.AGREGAR_INSTITUCION:
            let instituciones_agregar = state.educacion.listado_instituciones;

            instituciones_agregar = [
                ...instituciones_agregar, payload
            ];

            instituciones_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado_instituciones: instituciones_agregar
                }
            };

        case CONFIGURACION_EDUCACION.DETALLES_INSTITUCION:
            return {
                ...state,
                educacion: {
                    ...state.educacion, 
                    detalles_institucion: payload
                }
            };

        case CONFIGURACION_EDUCACION.EDITAR_INSTITUCION:
            let instituciones_editar = state.educacion.listado_instituciones;

            instituciones_editar = instituciones_editar.map(institucion => institucion._id === payload._id ? payload : institucion);

            instituciones_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado_instituciones: instituciones_editar
                }
            };

        case CONFIGURACION_EDUCACION.ELIMINAR_INSTITUCION:
            return {
                ...state, 
                educacion: {
                    ...state.educacion, 
                    listado_instituciones: state.educacion.listado_instituciones.filter( institucion => institucion._id !== payload.id )
                }
            };
    
        case CONFIGURACION_CATEGORIAS_EMPRESAS.BUSCAR:
            return {
                ...state,
                categorias_empresas: {
                    ...state.categorias_empresas, 
                    listado: payload
                }
            };

        case CONFIGURACION_CATEGORIAS_EMPRESAS.AGREGAR:
            let categorias_agregar = state.categorias_empresas.listado;

            categorias_agregar = [
                ...categorias_agregar, payload
            ];

            categorias_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                categorias_empresas: {
                    ...state.categorias_empresas, 
                    listado: categorias_agregar
                }
            };

        case CONFIGURACION_CATEGORIAS_EMPRESAS.DETALLES:
            return {
                ...state,
                categorias_empresas: {
                    ...state.categorias_empresas, 
                    detalles: payload
                }
            };

        case CONFIGURACION_CATEGORIAS_EMPRESAS.EDITAR:
            let categorias_editar = state.categorias_empresas.listado;

            categorias_editar = categorias_editar.map(categoria => categoria._id === payload._id ? payload : categoria);

            categorias_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                categorias_empresas: {
                    ...state.categorias_empresas, 
                    listado: categorias_editar
                }
            };

        case CONFIGURACION_CATEGORIAS_EMPRESAS.ELIMINAR:
            return {
                ...state, 
                categorias_empresas: {
                    ...state.categorias_empresas, 
                    listado: state.categorias_empresas.listado.filter( categoria => categoria._id !== payload.id )
                }
            };

        case CONFIGURACION_EXTENSIONES.BUSCAR:
            return {
                ...state,
                extensiones: {
                    ...state.extensiones, 
                    listado: payload
                }
            };

        case CONFIGURACION_EXTENSIONES.AGREGAR:
            let extensiones_agregar = state.extensiones.listado;

            extensiones_agregar = [
                ...extensiones_agregar, payload
            ];

            extensiones_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                extensiones: {
                    ...state.extensiones, 
                    listado: extensiones_agregar
                }
            };

        case CONFIGURACION_EXTENSIONES.DETALLES:
            return {
                ...state,
                extensiones: {
                    ...state.extensiones, 
                    detalles: payload
                }
            };

        case CONFIGURACION_EXTENSIONES.EDITAR:
            let extensiones_editar = state.extensiones.listado;

            extensiones_editar = extensiones_editar.map(extension => extension._id === payload._id ? payload : extension);

            extensiones_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                extensiones: {
                    ...state.extensiones, 
                    listado: extensiones_editar
                }
            };

        case CONFIGURACION_EXTENSIONES.ELIMINAR:
            return {
                ...state, 
                extensiones: {
                    ...state.extensiones, 
                    listado: state.extensiones.listado.filter( extension => extension._id !== payload.id )
                }
            };

        case CONFIGURACION_REQUERIMIENTOS.BUSCAR:
            return {
                ...state,
                requerimientos: {
                    ...state.requerimientos, 
                    listado: payload
                }
            };

        case CONFIGURACION_REQUERIMIENTOS.AGREGAR:
            let requerimientos_agregar = state.requerimientos.listado;

            requerimientos_agregar = [
                ...requerimientos_agregar, payload
            ];

            requerimientos_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                requerimientos: {
                    ...state.requerimientos, 
                    listado: requerimientos_agregar
                }
            };

        case CONFIGURACION_REQUERIMIENTOS.DETALLES:
            return {
                ...state,
                requerimientos: {
                    ...state.requerimientos, 
                    detalles: payload
                }
            };

        case CONFIGURACION_REQUERIMIENTOS.EDITAR:
            let requerimientos_editar = state.requerimientos.listado;

            requerimientos_editar = requerimientos_editar.map(requerimiento => requerimiento._id === payload._id ? payload : requerimiento);

            requerimientos_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                requerimientos: {
                    ...state.requerimientos, 
                    listado: requerimientos_editar
                }
            };

        case CONFIGURACION_REQUERIMIENTOS.ELIMINAR:
            return {
                ...state, 
                requerimientos: {
                    ...state.requerimientos, 
                    listado: state.requerimientos.listado.filter( requerimiento => requerimiento._id !== payload.id )
                }
            };

        case CONFIGURACION_DEPENDENCIAS.BUSCAR:
            return {
                ...state,
                dependencias: {
                    ...state.dependencias, 
                    listado: payload
                }
            };

        case CONFIGURACION_DEPENDENCIAS.EDITAR:
            let dependencias_editar = state.dependencias.listado;

            dependencias_editar = dependencias_editar.map(dependencia => dependencia._id === payload._id ? payload : dependencia);

            return {
                ...state, 
                dependencias: {
                    ...state.dependencias, 
                    listado: dependencias_editar
                }
            };
    
        case CONFIGURACION_CABINAS.BUSCAR:
            return {
                ...state,
                cabinas: {
                    ...state.cabinas, 
                    listado: payload
                }
            };

        case CONFIGURACION_CABINAS.AGREGAR:
            let cabinas_agregar = state.cabinas.listado;

            cabinas_agregar = [
                ...cabinas_agregar, payload
            ];

            cabinas_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                cabinas: {
                    ...state.cabinas, 
                    listado: cabinas_agregar
                }
            };

        case CONFIGURACION_CABINAS.DETALLES:
            return {
                ...state,
                cabinas: {
                    ...state.cabinas, 
                    detalles: payload
                }
            };

        case CONFIGURACION_CABINAS.EDITAR:
            let cabinas_editar = state.cabinas.listado;

            cabinas_editar = cabinas_editar.map(cabina => cabina._id === payload._id ? payload : cabina);

            cabinas_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                cabinas: {
                    ...state.cabinas, 
                    listado: cabinas_editar
                }
            };

        case CONFIGURACION_CABINAS.ELIMINAR:
            return {
                ...state, 
                cabinas: {
                    ...state.cabinas, 
                    listado: state.cabinas.listado.filter( cabina => cabina._id !== payload.id )
                }
            };
        
        case CONFIGURACION_AUDITORIOS.BUSCAR:
            return {
                ...state,
                auditorios: {
                    ...state.auditorios, 
                    listado: payload
                }
            };

        case CONFIGURACION_AUDITORIOS.AGREGAR:
            let auditorios_agregar = state.auditorios.listado;

            auditorios_agregar = [
                ...auditorios_agregar, payload
            ];

            auditorios_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                auditorios: {
                    ...state.auditorios, 
                    listado: auditorios_agregar
                }
            };

        case CONFIGURACION_AUDITORIOS.DETALLES:
            return {
                ...state,
                auditorios: {
                    ...state.auditorios, 
                    detalles: payload
                }
            };

        case CONFIGURACION_AUDITORIOS.EDITAR:
            let auditorios_editar = state.auditorios.listado;

            auditorios_editar = auditorios_editar.map(auditorio => auditorio._id === payload._id ? payload : auditorio);

            auditorios_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                auditorios: {
                    ...state.auditorios, 
                    listado: auditorios_editar
                }
            };

        case CONFIGURACION_AUDITORIOS.ELIMINAR:
            return {
                ...state, 
                auditorios: {
                    ...state.auditorios, 
                    listado: state.auditorios.listado.filter( auditorio => auditorio._id !== payload.id )
                }
            };

        case CONFIGURACION_PADELS.BUSCAR:
            return {
                ...state,
                padels: {
                    ...state.padels, 
                    listado: payload
                }
            };

        case CONFIGURACION_PADELS.AGREGAR:
            let padels_agregar = state.padels.listado;

            padels_agregar = [
                ...padels_agregar, payload
            ];

            padels_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                padels: {
                    ...state.padels, 
                    listado: padels_agregar
                }
            };

        case CONFIGURACION_PADELS.DETALLES:
            return {
                ...state,
                padels: {
                    ...state.padels, 
                    detalles: payload
                }
            };

        case CONFIGURACION_PADELS.EDITAR:
            let padels_editar = state.padels.listado;

            padels_editar = padels_editar.map(padel => padel._id === payload._id ? payload : padel);

            padels_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                padels: {
                    ...state.padels, 
                    listado: padels_editar
                }
            };

        case CONFIGURACION_PADELS.ELIMINAR:
            return {
                ...state, 
                padels: {
                    ...state.padels, 
                    listado: state.padels.listado.filter( padel => padel._id !== payload.id )
                }
            };

        case CONFIGURACION_GIMNASIOS.BUSCAR:
            return {
                ...state,
                gimnasios: {
                    ...state.gimnasios, 
                    listado: payload
                }
            };

        case CONFIGURACION_GIMNASIOS.AGREGAR:
            let gimnasios_agregar = state.gimnasios.listado;

            gimnasios_agregar = [
                ...gimnasios_agregar, payload
            ];

            gimnasios_agregar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                gimnasios: {
                    ...state.gimnasios, 
                    listado: gimnasios_agregar
                }
            };

        case CONFIGURACION_GIMNASIOS.DETALLES:
            return {
                ...state,
                gimnasios: {
                    ...state.gimnasios, 
                    detalles: payload
                }
            };

        case CONFIGURACION_GIMNASIOS.EDITAR:
            let gimnasios_editar = state.gimnasios.listado;

            gimnasios_editar = gimnasios_editar.map(gimnasio => gimnasio._id === payload._id ? payload : gimnasio);

            gimnasios_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                gimnasios: {
                    ...state.gimnasios, 
                    listado: gimnasios_editar
                }
            };

        case CONFIGURACION_GIMNASIOS.ELIMINAR:
            return {
                ...state, 
                gimnasios: {
                    ...state.gimnasios, 
                    listado: state.gimnasios.listado.filter( gimnasio => gimnasio._id !== payload.id )
                }
            };

        case CONFIGURACION_ASESORES.BUSCAR:
            return {
                ...state,
                asesores: {
                    ...state.asesores, 
                    listado: payload
                }
            };

        case CONFIGURACION_ASESORES.DETALLES:
            return {
                ...state,
                asesores: {
                    ...state.asesores, 
                    detalles: payload
                }
            };

        case CONFIGURACION_ASESORES.EDITAR:
            let asesores_editar = state.asesores.listado;

            asesores_editar = asesores_editar.map(asesor => asesor._id === payload._id ? payload : asesor);

            asesores_editar.sort(function (a, b) {
                if (a.nombre > b.nombre) {
                    return 1;
                }
                if (a.nombre < b.nombre) {
                    return -1;
                }
                return 0;
            });

            return {
                ...state, 
                asesores: {
                    ...state.asesores, 
                    listado: asesores_editar
                }
            };
    
        default:
            return state;
    }
}